module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"choose format":"Format wählen","portrait":"Hochformat (9:16)","landscape":"Querformat (16:9)","copyright":"Copyright ©2020 touchwert®<br>touchwert® ist eine eingetragene Marke der bestzoom GmbH<br>touchwert creator V2.0"}}')
  delete Component.options._Ctor
}
